import { AspectRatio } from 'react-aspect-ratio';
import Profile from '../assets/images/profile.png';
import Cover from '../assets/images/cover.jpg';

export default function Avatar({ user, className = '' }) {
	return <img className={"avatar " + className} src={(user && user.avatar && user.avatar.access_url) || Profile} />;
}

export function UserCover({ user }) {
	return <AspectRatio ratio={1000/250} className="cover" style={{ backgroundImage: 'url("' + ((user.cover && user.cover.access_url) || Cover) + '")' }}>
		<div>
			<Avatar user={user} />
		</div>
	</AspectRatio>;
}
